package com.downdogapp.client.widget

import com.downdogapp.*
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement

interface RangeSlider {

  var proportion: Double
  var value: Double
  fun setValueNoUpdate(value: Double)

  private class RangeSliderImpl(parent: HTMLElement,
                                private val valueRange: DoubleRange,
                                startValue: Double,
                                className: String?,
                                private val innerRangeMin: Int,
                                private val innerRangeMax: Int,
                                private val onMouseDown: RangeSlider.() -> Unit,
                                private val onValueChanged: RangeSlider.() -> Unit,
                                private val onMouseUp: RangeSlider.() -> Unit,
                                private var block: HTMLInputElement.() -> Unit) : RangeSlider {

    private var slider: HTMLInputElement

    override var proportion: Double
      get() = slider.value.toDouble() / innerRangeMax
      set(proportion) {
        value = valueRange.start + proportion * valueRange.size
      }

    override var value: Double
      get() = proportion * valueRange.size + valueRange.start
      set(value) {
        slider.value = getSliderValue(value)
        onValueChanged()
      }

    init {
      parent.apply {
        slider = input {
          this.className = className ?: ""
          type = "range"
          min = innerRangeMin.toString()
          max = innerRangeMax.toString()
          value = getSliderValue(startValue)
          onmousedown = { onMouseDown() }
          oninput = {
            onValueChanged()
          }
          onmouseup = { onMouseUp() }

          block()
        }
      }
    }

    override fun setValueNoUpdate(value: Double) {
      if (slider.value != getSliderValue(value)) {
        slider.value = getSliderValue(value)
      }
    }

    private fun getSliderValue(value: Double) =
      (value.coerceIn(valueRange) / valueRange.endInclusive * innerRangeMax)
        .toInt()
        .toString()
  }

  companion object {

    fun HTMLElement.rangeSlider(valueRange: DoubleRange,
                                startValue: Double = 0.0,
                                className: String? = null,
                                innerRangeMin: Int = 0,
                                innerRangeMax: Int = 10000,
                                onMouseDown: RangeSlider.() -> Unit = {},
                                onValueChanged: RangeSlider.() -> Unit = {},
                                onMouseUp: RangeSlider.() -> Unit = {},
                                block: HTMLInputElement.() -> Unit = {}): RangeSlider =
      RangeSliderImpl(
        parent = this,
        valueRange = valueRange,
        startValue = startValue,
        className = className,
        innerRangeMin = innerRangeMin,
        innerRangeMax = innerRangeMax,
        onMouseDown = onMouseDown,
        onValueChanged = onValueChanged,
        onMouseUp = onMouseUp,
        block = block
      )
  }
}
